import { render, staticRenderFns } from "./TwStandardFieldSettingDialog.vue?vue&type=template&id=15cba6ce&scoped=true&"
import script from "./TwStandardFieldSettingDialog.vue?vue&type=script&lang=js&"
export * from "./TwStandardFieldSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./TwStandardFieldSettingDialog.vue?vue&type=style&index=0&id=15cba6ce&lang=scss&scoped=true&"
import style1 from "./TwStandardFieldSettingDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cba6ce",
  null
  
)

export default component.exports